import React, { useEffect, useState } from "react";
import Loader from "../../../components/common/Loader";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import apiLink from "../../../api/apiLink";
import { toast } from "react-toastify";
import useISPowner from "../../../hooks/useISPOwner";

const ResellerRechargeSmsTemplate = () => {
  const { t } = useTranslation();

  //---> @Get user & current user data form useISPOwner hooks
  const { ispOwnerId, bpSettings, settings } = useISPowner();

  // loading state
  const [loading, setLoading] = useState(false);

  // SMS state
  const [rechargeSMS, setRechargeSMS] = useState(false);

  // message type status
  const [sendingType, setSendingType] = useState();

  const messageTypes = [
    {
      name: "nonMasking",
      label: t("nonMasking"),
      value: "nonMasking",
    },
    {
      name: "masking",
      label: t("masking"),
      value: "masking",
    },
    {
      name: "fixedNumber",
      label: t("fixedNumber"),
      value: "fixedNumber",
    },
    ...(bpSettings?.hasSmsGateway
      ? [
          {
            name: "personalGateway",
            label: t("personalGateway"),
            value: "personalGateway",
          },
        ]
      : []),
  ];

  // handle submit method
  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      ...settings.sms,
      resellerRechargeSendBy: sendingType,
      resellerRecharge: rechargeSMS,
    };
    setLoading(true);

    // api call
    try {
      await apiLink.patch(`/ispOwner/settings/sms/${ispOwnerId}`, data);
      setLoading(false);
      toast.success(t("rechargeSMSToast"));
    } catch (error) {
      setLoading(false);
    }
  };

  // set reseller recharge sms setting in state
  useEffect(() => {
    setRechargeSMS(settings.sms.resellerRecharge);
    setSendingType(settings?.sms?.resellerRechargeSendBy);
  }, [settings]);

  return (
    <div>
      <div className="writeMessageSection">
        <div className="messageStatus d-flex justify-content-between">
          <div className="sending-status">
            <h4> {t("resellerRechargeTemplate")} </h4>
            <div className="displayGrid1">
              <div className="message_radio">
                <input
                  type="radio"
                  name="rechargeSMS"
                  id="onTemplate_recharge"
                  checked={rechargeSMS}
                  onChange={() => setRechargeSMS(true)}
                />
                <label htmlFor="onTemplate_recharge">{t("ON")}</label>
              </div>

              <div className="message_radio">
                <input
                  type="radio"
                  name="rechargeSMS"
                  id="offTemplate_recharge"
                  checked={!rechargeSMS}
                  onChange={() => setRechargeSMS(false)}
                />
                <label htmlFor="offTemplate_recharge">{t("OFF")}</label>
              </div>
            </div>
          </div>
          <div className="message-sending-type">
            <h4>{t("sendingMessageType")}</h4>
            <div className="smsType">
              {messageTypes.map((type) => (
                <div className="message_radio" key={type.value}>
                  <input
                    type="radio"
                    id={type.value + "recharge"}
                    value={type.value}
                    onChange={(event) => setSendingType(event.target.value)}
                    checked={sendingType === type.value}
                  />
                  <label htmlFor={type.value + "recharge"}>{type.label}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <hr />
      <button type="submit" onClick={handleSubmit} className="btn btn-success">
        {loading ? <Loader /> : t("save")}
      </button>
    </div>
  );
};

export default ResellerRechargeSmsTemplate;
